import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Yellow_Outline_Btn.css";

const Yellow_Outline_Btn = ({
  rightIcon,
  leftIcon,
  disabled,
  onClick,
  btnText,
  type = "button",
  ...props
}) => {
  return (
    <button
      className="Yellow_Outline_Btn"
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {leftIcon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={leftIcon} className="left_icon" />
        </div>
      )}

      <p className="btn_text">{btnText}</p>

      {rightIcon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={rightIcon} className="right_icon" />
        </div>
      )}
    </button>
  );
};

export default Yellow_Outline_Btn;
